module.exports = __webpack_public_path__ + "static/media/filter.d19ff2a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/images/filter.svg
// module id = 7406
// module chunks = 0